import React from 'react'
import { NotificationsContent } from '../components/Notifications/NotificationsContent'
export const Notifications = () => {
  return (
    <NotificationsContent />
  )
}
